<script setup lang="ts">
import type { InsightWorkbenchTab } from '../../../models/workbench.types'

import { useI18n } from '@/shared/i18n'
import { Tabs, type TabOption, type TabValue } from '@/shared/ui/tabs'

const tab = defineModel<InsightWorkbenchTab>({ required: true })
const { t } = useI18n()
const tabs: TabOption[] = [
  { value: 'preview', label: t('insights.sysadmin.tabs.preview') },
  { value: 'config', label: t('insights.sysadmin.tabs.config') },
  { value: 'history', label: t('insights.sysadmin.tabs.history') },
]

function update(value: TabValue | null): void {
  if (value === 'preview' || value === 'config' || value === 'history') tab.value = value
}
</script>

<template>
  <Tabs
    :model-value="tab"
    :tabs="tabs"
    :aria-label="t('insights.sysadmin.tabs.label')"
    @update:model-value="update"
  >
    <template #panel-preview><slot name="preview" /></template>
    <template #panel-config><slot name="config" /></template>
    <template #panel-history><slot name="history" /></template>
  </Tabs>
</template>
